<template>
  <div
    v-tooltip.left="'Add text marker'"
    class="text-bubble-control control"
    :class="{toggled: value}"
    @click="toggleTextBubble"
  >
    <img v-if="!value" src="../../assets/icon_text_bubble.svg" style="height: 24px;"/>
    <img v-if="value" src="../../assets/icon_text_bubble_brand_secondary.svg" style="height: 24px;"/>
  </div>
</template>

<script>
  export default {
    name: 'TextBubbleControl',
    props: {
      value: {
        type: Boolean
      }
    },

    methods: {
      toggleTextBubble() {
        this.$emit('input', !this.value)
      }
    }
  }
</script>

<style lang="scss">
@import "TextBubbleControl";
</style>
